import { useTranslation } from 'react-i18next';

// Material UI imports
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';


const ThankYou = () => {
    const { t } = useTranslation();

    return (
        <Fade in timeout={1000}>
            <div className='main'>
                <Box sx={{
                    background: 'linear-gradient(0.25turn, rgb(91, 59, 140), rgb(118, 93, 160), rgb(118, 093, 160))',
                    color: '#fff',
                    width: { xs: '100%', sm: '70%', md: '50%' },
                    maxWidth: '35rem',
                    minHeight: '20rem',
                    margin: '0 auto',
                    padding: '2rem',
                    borderRadius: '15px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    }}>
                    <CheckCircleOutlineIcon sx={{ fontSize: '4rem', color: '#fff', mb: 2 }} />
                    <Typography variant='h4' sx={{ textAlign: 'center', mb: { xs: 2, sm: 4 } }}>{t(`survey.thank_you`)}</Typography>
                    <Typography variant='h6' sx={{ lineHeight: '2', textAlign: 'center' }}>
                        {t(`survey.thank_you_description`)}
                    </Typography>
                </Box>
            </div>
        </Fade>
    )
}

export default ThankYou;
